import React from 'react';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Classes from '../common/Classes';
import StringFormatter from '../common/StringFormatter';
import Tags from '../common/dtmTags';
import { ImageSizes, DataDtmActions } from '../common/Constants';
import ProducerDirectoryImage from './ProducerDirectoryImage';

class Producer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  generateProducers() {
    const { artists = [] } = this.props;
    return artists.map(artist => this.generateProducer(artist));
  }

  generateProducer = (producer) => {
    const {
      artistDetailsUrlFormat, translations, isRounded, defaultArtistLogoUrl
    } = this.props;
    const linkURL = StringFormatter.format(artistDetailsUrlFormat, producer.id);
    const dataDtm = Tags.producerDirectory.producer;
    const artistImageProps = {
      alt: translations.artistImageAltText,
      imageSize: ImageSizes.artist,
      isInnovative: producer.isInnovative,
      src: producer.profileImage,
      translations: translations.exhibitorDetails,
      isRounded,
      defaultArtistLogoUrl
    };

    const customClasses = `${Classes.artistTile} ${Classes.enhancement}`;
    return (
      <Col xs={16} sm={6} md={4} className={customClasses} key={producer.id}>
        <a
          href={linkURL}
          data-dtm={dataDtm}
          data-dtm-actions={DataDtmActions.view}
          data-dtm-attributes={JSON.stringify({ producerId: producer.id })}
        >
          <div>
            <ProducerDirectoryImage {...artistImageProps} />
            <h4 className={Classes.artistName} >{producer.firstName} {producer.lastName}</h4>
          </div>
        </a>
      </Col>
    );
  };

  render() {
    return (<Row>{this.generateProducers()} </Row>);
  }
}

Producer.propTypes = {
  artists: PropTypes.arrayOf(PropTypes.object),
  hasMore: PropTypes.bool,
  refine: PropTypes.func,
  artistDetailsUrlFormat: PropTypes.string.isRequired,
  defaultArtistLogoUrl: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
  isRounded: PropTypes.bool
};

export default Producer;
